module.exports = __webpack_public_path__ + "a52608da8aa36a9a1091ceb94030d439.svg";